<template>
  <div
    class="suisenjo bg-white border-2 border-gray-300 p-3 rounded-md tracking-wide mb-3"
    v-if="showState.show"
  >
    <button @click="showState.show = !showState.show" class="show-btn">
      非表示
    </button>
    <div class="h-1/4 flex items-center">
      <div class="w-2/6 flex-shrink-0 pr-5">
        <Thumb :userAvatarName="userAvatarName" />
      </div>
      <div class="flex-shrink">
        <div class="text-3xl mb-5">
          <span class="text-3xl">{{ userName }}</span> さんは<br />選挙愛子
          さんを応援します！
        </div>
        <div class="text-3xl">{{ userMessage }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media print {
  .suisenjo {
    page-break-inside: avoid;
    margin: 0;
  }
  .show-btn {
    display: none;
  }
}
</style>

<script>
import { reactive } from 'vue'
import Thumb from './Thumb.vue'

export default {
  components: { Thumb },
  props: {
    user: Object
  },
  setup(props) {
    const userName = reactive(props.user.ニックネームまたはお名前)
    const userMessage = reactive(props.user.応援メッセージ)
    const userAvatarName = reactive(props.user.アバター)
    const showState = reactive({ show: true })
    if (!userAvatarName) {
      showState.show = !showState.show
    }

    return {
      userName,
      userMessage,
      userAvatarName,
      showState
    }
  }
}
</script>
